// @flow

import type {
  TermFilters, RangeFilters, CustomFilters, GlobalState,
} from '../types';
import applyRangeFilter from './applyRangeFilter';
import applyTermFilter from './applyTermFilter';
import applyCustomFilter from './applyCustomFilter';

const applyFiltering = (
  state: GlobalState,
  assortment: Array<string>,
  termFilters?: TermFilters,
  rangeFilters?: RangeFilters,
  customFilters?: CustomFilters,
): Array<string> => assortment.filter(pdbId => applyTermFilter(state, pdbId, termFilters)
  && applyRangeFilter(state, pdbId, rangeFilters)
  && applyCustomFilter(state, pdbId, customFilters));

export default applyFiltering;
